import type { PoolChoice } from '../../../Services/OrderWizard/pools.ts'
import { PoolSelect } from './Primitives.tsx'

/** Above the board while items are selected: move, mark or remove them, the keyboard and screen-reader path. */
export const SelectionBar = ({
  selected,
  pools,
  moveTarget,
  onMoveTarget,
  onMove,
  markLabel,
  onMark,
  onRemove,
  onClear
}: {
  selected: number
  /** Absent in the one-pool list, which moves nothing. */
  pools?: readonly PoolChoice[]
  moveTarget?: string
  onMoveTarget?: (value: string) => void
  onMove?: () => void
  markLabel: string
  onMark: () => void
  onRemove: () => void
  onClear: () => void
}) => (
  <div
    className="flex h-9 flex-nowrap items-center gap-2 overflow-x-auto overflow-y-hidden whitespace-nowrap rounded border border-slate-200 bg-slate-50 px-2"
    role="region"
    aria-label="Selected items"
    data-testid="wizard-board-selection"
  >
    <span className="font-medium text-slate-800" data-testid="wizard-board-selected-count">
      {selected} selected
    </span>
    <span className="text-slate-500">·</span>
    {pools && (
      <>
        <label className="flex shrink-0 items-center gap-1 whitespace-nowrap text-slate-700">
          Move to
          <PoolSelect
            pools={pools}
            aria-label="Move the selected items to"
            data-testid="wizard-board-move-target"
            value={moveTarget ?? ''}
            onChange={(value) => onMoveTarget?.(value)}
          />
        </label>
        <button type="button" className="btn btn-xs" data-testid="wizard-board-move" disabled={!moveTarget} onClick={onMove}>
          Move
        </button>
        <span className="text-slate-500">·</span>
      </>
    )}
    <button type="button" className="btn btn-xs" data-testid="wizard-board-mark" onClick={onMark}>
      {markLabel}
    </button>
    <button type="button" className="btn btn-xs" data-testid="wizard-board-remove" onClick={onRemove}>
      Remove
    </button>
    <button type="button" className="btn btn-ghost btn-xs" data-testid="wizard-board-clear" onClick={onClear}>
      Clear
    </button>
  </div>
)
